var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPng = function SvgPng(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#png_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 15,
    y: 24,
    fill: "#C0BEBE",
    rx: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 15,
    y: 34.5,
    fill: "#C0BEBE",
    rx: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 20.25,
    y: 29.25,
    fill: "#C0BEBE",
    rx: 0.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 24.75,
    y: 24,
    fill: "#C0BEBE",
    rx: 0.75
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 24.75,
    y: 34.5,
    fill: "#C0BEBE",
    rx: 0.75
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 29.25,
    y: 29.25,
    fill: "#C0BEBE",
    rx: 0.75
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 34.5,
    y: 24,
    fill: "#C0BEBE",
    rx: 0.75
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 34.5,
    y: 34.5,
    fill: "#C0BEBE",
    rx: 0.75
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#A41CFF",
    rx: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.262 18v-6h2.59q.667 0 1.17.264.5.264.778.74.279.479.279 1.117 0 .645-.287 1.116-.284.472-.8.727-.513.255-1.198.255H8.247v-1.266h1.218q.288 0 .49-.1a.73.73 0 0 0 .313-.29.85.85 0 0 0 .111-.442.83.83 0 0 0-.11-.44.7.7 0 0 0-.314-.28 1.1 1.1 0 0 0-.49-.1h-.574V18zm10.606-6v6h-1.36l-2.167-3.152h-.036V18h-1.629v-6h1.383l2.133 3.14h.047V12zm4.667 1.98a.8.8 0 0 0-.12-.272.839.839 0 0 0-.486-.328 1.3 1.3 0 0 0-.35-.044 1.2 1.2 0 0 0-.7.196q-.285.197-.439.566-.15.37-.15.89 0 .528.144.903.143.375.428.574.285.2.706.2.372 0 .618-.11a.8.8 0 0 0 .372-.307.87.87 0 0 0 .123-.469l.281.03h-1.37v-1.16h2.66v.832q0 .82-.349 1.403a2.3 2.3 0 0 1-.955.89q-.606.308-1.392.308-.876 0-1.538-.372a2.6 2.6 0 0 1-1.034-1.06q-.37-.69-.37-1.638 0-.744.226-1.319.23-.574.633-.97.404-.397.935-.6a3.1 3.1 0 0 1 1.137-.205q.532 0 .99.152.46.15.811.428.355.275.572.653t.263.83z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "png_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgPng;